import { render, staticRenderFns } from "./ReportDetailData.vue?vue&type=template&id=7940356a&"
import script from "./ReportDetailData.vue?vue&type=script&lang=ts&"
export * from "./ReportDetailData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports